query ApprovalsChartData {
  kpiApprovalTypes {
    nodes {
      title
      amount
    }
  }
}
